<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Reportes - Premios" />
    <Report />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Report from "@/components/Pages/Admin/Reports/tournament-players-prizes.vue";

export default defineComponent({
  name: "ReportTournamentPlayersPrizePage",
  components: {
    PageTitle,
    Report,
  },
});
</script>
